import React, { memo, useContext } from 'react';
import { Blok } from '../../../../interfaces/Blok.interface';
import { withBlokWrapper } from '../../../BlokWrapper/BlokWrapper';
import { Theme } from '../../../../interfaces/enums/Theme.enum';
import Grid from '../../../Utils/Grid/Grid';
import Col from '../../../Utils/Col/Col';
import ButtonLink from '../../../ButtonLink/ButtonLink';
import { ButtonType } from '../../../../interfaces/enums/ButtonType.enum';
import { ButtonSize } from '../../../../interfaces/enums/ButtonSize.enum';
import { LinkProps } from '../../../../interfaces/LinkProps.interface';
import { useDispatch } from 'react-redux';
import { setModalState } from '../../../../store/slices/quote/quote.store';
import { QuoteContext } from '../../../../contexts/Quote';
import { postQuoteOverviewToDataLayer } from '../../../../utils/postQuoteOverviewToDataLayer/postQuoteOverviewToDataLayer.util';

interface QuoteButtonsBarProps {
  primary_cta: LinkProps[];
  secondary_cta: LinkProps[];
}

const QuoteButtonsBar: React.FC<QuoteButtonsBarProps> = ({
  primary_cta,
  secondary_cta,
}) => {
  const { quoteCostBreakdown, quoteReference, trackingRef } =
    useContext(QuoteContext);

  const handlePostQuoteOverviewToDataLater = (eventName: string): void => {
    postQuoteOverviewToDataLayer(
      eventName,
      quoteReference!,
      trackingRef!,
      quoteCostBreakdown!
    );
  };

  const dispatch = useDispatch();
  return (
    <div className="px-10 py-8">
      <Grid>
        <Col span={{ sm: 6 }}>
          {secondary_cta.map((cta: LinkProps) => (
            <div key={cta._uid}>
              {cta.component === 'save_for_later_cta' ? (
                <ButtonLink
                  onClick={(e: React.MouseEvent<HTMLElement>) => {
                    e.preventDefault();
                    handlePostQuoteOverviewToDataLater('quote_step2_save');
                    dispatch(
                      setModalState({
                        isQuoteModalOpen: true,
                        quoteModalContent: 'saveForLater',
                      })
                    );
                  }}
                  label={cta.label}
                  type={ButtonType.TERTIARY}
                  size={ButtonSize.XL}
                  className="w-full"
                >
                  {cta.label}
                </ButtonLink>
              ) : (
                <ButtonLink
                  url={cta.link?.cached_url}
                  label={cta.label}
                  type={ButtonType.TERTIARY}
                  size={ButtonSize.XL}
                  className="w-full"
                >
                  {cta.label}
                </ButtonLink>
              )}
            </div>
          ))}
        </Col>
        <Col span={{ sm: 6 }}>
          {primary_cta.map((cta: LinkProps) => (
            <div key={cta._uid}>
              <ButtonLink
                label={cta.label}
                type={ButtonType.PRIMARY}
                size={ButtonSize.XL}
                className="w-full"
                btnType="submit"
              >
                {cta.label}
              </ButtonLink>
            </div>
          ))}
        </Col>
      </Grid>
    </div>
  );
};

export default memo(withBlokWrapper(QuoteButtonsBar, Theme.DARKEST));
